import {DumpsterFire} from "../DumpsterFire";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {SlideShowPage} from "@nolimitcity/slot-keypad/bin/core/app/gui/views/slideshow/SlideShowPage";
import {FontStyle, FontWeight} from "@nolimitcity/slot-keypad/bin/core/loaders/font/FontStatics";


export class IntroSlideShow extends SlideShowPage {

    constructor(texture: PIXI.Texture, showText: boolean) {
        super(undefined, undefined, undefined, undefined);

        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fontFamily: "Kirsty",
            fontStyle: FontStyle.NORMAL,
            fontWeight: FontWeight.BOLD,
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 4,
            dropShadowDistance: 2,
            fill: "#f9cb45",
            fontSize: 35,
            lineJoin: "round",
            // stroke: "#434343",
            strokeThickness: 4
        });

        const featureImage: PIXI.Sprite = new PIXI.Sprite(texture);
        featureImage.anchor.set(0.5);
        this.addChild(featureImage);

        if (showText) {
            const textObj: PIXI.Text = new PIXI.Text(DumpsterFire.apiPlugin.translations.translate("WIN UP TO") + " 30 000x " + DumpsterFire.apiPlugin.translations.translate("BET"), textStyle);
            textObj.anchor.set(0.5);
            textObj.position.set(0, 140);
            if (DumpsterFire.apiPlugin.gameClientConfiguration.isSet) {
                if (!DumpsterFire.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                    textObj.visible = false;
                }
            } else {
                DumpsterFire.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if (!DumpsterFire.apiPlugin.gameClientConfiguration.showLowProbabilityGfx) {
                        textObj.visible = false;
                    }
                });
            }

            this.addChild(textObj);
        }
    }
}